
import { lazyPreloadComponent } from "../libs/helpers/preload";
import { ROUTE_NAMES } from "./route-names";
import Landing from "../containers/home-insurance-landing";


export const Thanks = lazyPreloadComponent(() =>
    import("../containers/home-insurance-thanks")
);

const ROUTES = {
    HOME_INSURANCE: {
        _MAIN: ROUTE_NAMES.HOME_INSURANCE._MAIN,
        LANDING: ROUTE_NAMES.HOME_INSURANCE.LANDING,
        THANKS: ROUTE_NAMES.HOME_INSURANCE.THANKS,
    },
};


export const ROUTES_COMPONENTS = {
    HOME_INSURANCE: {
        LANDING: Landing,
        THANKS: Thanks,
    },
};

export const HOME_INSURANCE_ROUTES_REGEX = `(${Object.values(ROUTES.HOME_INSURANCE)
    .map(route => `${route}`)
    .join("|")})`;

export const QUOTATION_FLOW_ROUTES_VALIDATION = {
    HOME_INSURANCE: {
        [ROUTES.HOME_INSURANCE.LANDING]: {
            validate: () => true,
        },
        [ROUTES.HOME_INSURANCE.THANKS]: {
            validate: state => {
                const {
                    HomeInsurance: {
                        crmOracle
                    },
                } = state;
                return crmOracle.done
            },
            redirectPath: ROUTES.HOME_INSURANCE.LANDING,
        },
    },
};

export const ROUTES_PRELOAD_CONFIG = {
    HOME_INSURANCE: {
        [ROUTES.HOME_INSURANCE.LANDING]: [],
        [ROUTES.HOME_INSURANCE.THANKS]: [],
    },
};

export const toPartnerRoute = (routePartnerPrefix, targetRoute) => {
    let newRoute = routePartnerPrefix;
    newRoute += routePartnerPrefix
        ? targetRoute.replace(`/${routePartnerPrefix}`)
        : targetRoute;
    return newRoute;
};

export const applyPartnerPrefixInRoutesConfigs = (() => {
    let partnerized = false;
    return routePartnerPrefix => {
        if (partnerized) return;
        const targetConfigs = [
            ROUTES.HOME_INSURANCE.LANDING,
            ROUTES.HOME_INSURANCE.THANKS,
        ];
        targetConfigs.forEach(TARGET_CONFIG => {
            Object.assign(
                {},
                TARGET_CONFIG,
                toPartnerRoute(routePartnerPrefix, TARGET_CONFIG)
            );
        });
        partnerized = true;
    };
})();

export default ROUTES;
